import React, { useEffect } from "react";
import { useAppDispatch } from "../../../hooks";
import { resetProjectInRedux } from "../../actions";
import UserItemsInProject from "../projectdashboard/ActiveAssignedItems/UserItemsInProject";

export const MyTasksPage: React.FC = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(resetProjectInRedux());
  }, []);

  return <UserItemsInProject app={"mytaskspage"} />;
};
